<template>
	<section class="px-4 md:px-8 bg-white mt-10 max-w-7xl mx-auto mb-14">
		<div class="columns-1 sm:columns-2 lg:columns-3 gap-8 lg:gap-16">
			<div
				v-for="category in categories"
				:key="category.id"
				class="mb-8 break-inside-avoid inline-block w-full"
			>
				<CategoryCard 
					v-bind="category" 
					:isScreen="false" 
					:hide_label="hide_label" 
					@sectorSelected="onSectorSelected"
				/>
			</div>
		</div>
	</section>
</template>

<script lang="js" src="./CategoryGrid"></script>